import React from 'react';
import JsxHelper from '../../../Helpers/JsxHelper';
import LookupText from '../../../Elements/LookupText';
import LookupTextArray from '../../../Elements/LookupTextArray';
import EvaluatorItem from './EvaluatorItem';

export default class PersonaExportItem extends EvaluatorItem {
  static Currency() {
    return 'USD';
  }

  static CurrencySecondary() {
    return 'USD';
  }

  static DateFields = [
    'SassiePpacceptedOn',
    'TipaltiLastDataCheck',
    'EvBday',
    'EvLastShop',
    'EvInactive',
    'EvFraudGroupModifiedOn',
    'EvSignDate',
    'EvLastlogin',
  ];

  static BoolFields = [
    'Emailchanged',
    'EvInternational',
    'EvEmailoptout',
    'EvIsAgency',
    'EvVat',
    'EvVatexp',
    'EvPaymentOfficeOverride',
    'EvDdpverify',
    'TipaltiPayableStatus',
    'EvaluatorExtendedEvexVehicle',
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Apollo Id', orderById: 'EvSassieId', data: 'EvSassieId', minWidth: '100px' },
      { label: 'Apollo Account Status', orderById: 'EvStatus', data: 'EvStatus', minWidth: '120px' },
      { label: 'City', orderById: 'EvCity', data: 'EvCity' },
      { label: 'State', orderById: 'EvState', data: 'EvState' },
      { label: 'ZIP', orderById: 'EvZipCode', data: 'EvZipCode' },
      { label: 'Country', orderById: 'EvCountry', data: 'CountryName' },
      { label: 'Gender', orderById: 'EvaluatorExtendedEvexSex', data: 'EvaluatorExtendedEvexSex' },
      { label: 'Birthday', orderById: 'EvBday', data: 'EvBday' },
      { label: 'Last Rating', orderById: 'EvLastRating', data: 'EvLastRating' },
      { label: 'Avg Rating', orderById: 'EvRating', data: 'EvRating' },
      { label: 'Profile Language', orderById: 'ApolloLanguageName', data: 'ApolloLanguageName' },
      { label: 'Email Verified', orderById: 'EvEmailVerifiedYN', data: 'EvEmailVerifiedYN' },
      { label: 'Opted out from emails?', orderById: 'EvEmailoptout', data: 'EvEmailoptoutYN' },
      { label: 'Sign-up Date', orderById: 'EvSignDate', data: 'EvSignDate' },
      { label: 'Last Login Date', orderById: 'EvLastlogin', data: 'EvLastlogin' },
      { label: 'All Shops In n Days #', orderById: 'AllShopsCountLastNDays', data: 'AllShopsCountLastNDays' },
      {
        label: 'Excluded Shops In n Days #',
        orderById: 'ExcludedShopsCountLastNDays',
        data: 'ExcludedShopsCountLastNDays',
        minWidth: 110,
      },
      {
        label: 'Excluded PS In n Days #',
        orderById: 'ExcludedPSShopsCountLastNDays',
        data: 'ExcludedPSShopsCountLastNDays',
        minWidth: 110,
      },
      {
        label: 'Finalized/Locked Shops In n Days #',
        orderById: 'FinalizedLockedShopsCountLastNDays',
        data: 'FinalizedLockedShopsCountLastNDays',
      },
      {
        label: 'Referral Client Shops In n Days #',
        orderById: 'ReferralClientShopsCountLastNDays',
        data: 'ReferralClientShopsCountLastNDays',
        minWidth: 120,
      },
      { label: 'Last Shop Date', orderById: 'EvLastShop', data: 'EvLastShop' },
      {
        label: 'ESP Languages Fluent In',
        orderById: 'EvaluatorExtendedEvexLangSpoken',
        data: (item) => (
          <LookupTextArray
            lookupId={98}
            valueArray={item.EvaluatorExtendedEvexLangSpoken}
          />
        ),
      },
      {
        label: 'ESP Citizenship',
        orderById: 'EvaluatorExtendedEvexCitizenship',
        data: (item) => (
          <LookupText
            lookupId={101}
            value={item.EvaluatorExtendedEvexCitizenship}
          />
        ),
      },
      {
        label: 'ESP Motorized Vehicle Type',
        orderById: 'EvaluatorExtendedEvexVehicleBrand',
        data: (item) => (
          <LookupText
            lookupId={102}
            value={item.EvaluatorExtendedEvexVehicleBrand}
          />
        ),
      },
      {
        label: 'ESP Tablet',
        orderById: 'EvaluatorExtendedEvexTablet',
        data: (item) => JsxHelper.YesNoEmpty(item.EvaluatorExtendedEvexTablet, 1, 2),
      },
    ];
  }
}
